import { Theme } from "@emotion/react";

// NOTE: 공통 이미지
export const image = {
  logo: require("./asset/images/logo.svg"),
  logo_white: require("./asset/images/logo-white.svg"),
  logo_black: require("./asset/images/logo-black.svg"),
  logo_green: require("./asset/images/logo-green.png"),
  logo_green_svg: require("./asset/images/logo-green.svg"),
  shopping_bag: require("./asset/images/shopping-bag.svg"),
  noti: require("./asset/images/noti.svg"),
  default_card_image: require("./asset/images/default_card_image.svg"),

  language: require("./asset/images/language.svg"),
  homeEvent: require("./asset/images/home-event.svg"),
  default: require("./asset/images/default.png"),
  love: require("./asset/images/love.svg"),
  chat: require("./asset/images/chat.svg"),
  chat_black: require("./asset/images/chat-black.svg"),
  sub_bg_1: require("./asset/images/sub-bg-1.svg"),
  sub_bg_2: require("./asset/images/sub-bg-2.svg"),
  like: require("./asset/images/like.svg"),
  like_full: require("./asset/images/like-full.svg"),
  login_background: require("./asset/images/login-bg.svg"),
  phone: require("./asset/images/phone.svg"),
  default_user: require("./asset/images/default-user.svg"),
  radio_off: require("./asset/images/radio-off.svg"),
  radio_on: require("./asset/images/radio-on.svg"),

  arrow_right: require("./asset/images/arrow-right.svg"),
  arrow_left: require("./asset/images/arrow-left.svg"),
  arrow_up: require("./asset/images/arrow-up.svg"),
  arrow_down: require("./asset/images/arrow-down.svg"),
  arrow_down_white: require("./asset/images/arrow-down-white.svg"),
  arrow_down_black: require("./asset/images/arrow-down-black.svg"),

  arrow_up_gray: require("./asset/images/arrow-up-gray.svg"),
  arrow_down_gray: require("./asset/images/arrow-down-gray.svg"),
  arrow_left_white: require("./asset/images/arrow-left-white.svg"),
  arrow_right_white: require("./asset/images/arrow-right-white.svg"),
  arrow_right_mint: require("./asset/images/arrow-right-mint.svg"),
  close_white: require("./asset/images/close-white.svg"),
  close: require("./asset/images/close.svg"),
  close_round: require("./asset/images/close-round.svg"),
  close_transparent: require("./asset/images/close-transparent.svg"),
  warning_circle: require("./asset/images/warning-circle.svg"),
  warning_circle_thin: require("./asset/images/warning-circle-thin.svg"),
  success_box: require("./asset/images/success-box.svg"),
  fail_box: require("./asset/images/fail-box.svg"),
  check_green: require("./asset/images/check-green.svg"),
  check_mint: require("./asset/images/check-mint.svg"),
  check_gray: require("./asset/images/check-gray.svg"),
  check_orange: require("./asset/images/check-orange.svg"),
  plus_gray: require("./asset/images/plus-gray.svg"),

  //Icon
  home_icon: require("./asset/images/home-icon.svg"),
  home_icon_black: require("./asset/images/home-black-icon.svg"),
  explore_icon: require("./asset/images/explore-icon.svg"),
  explore_icon_black: require("./asset/images/explore-black-icon.svg"),
  sell_icon: require("./asset/images/sell-icon.svg"),
  sell_icon_black: require("./asset/images/sell-black-icon.svg"),
  love_icon: require("./asset/images/love-icon.svg"),
  love_icon_black: require("./asset/images/love-black-icon.svg"),
  love_icon_white: require("./asset/images/love-icon-white.svg"),
  person_icon: require("./asset/images/person-icon.svg"),
  person_icon_black: require("./asset/images/person-black-icon.svg"),
  edit_icon: require("./asset/images/edit-icon.svg"),
  tag_icon: require("./asset/images/tag-icon.svg"),
  success_icon: require("./asset/images/success-icon.svg"),
  share_icon: require("./asset/images/share-icon.svg"),
  check_circle: require("./asset/images/check-circle-icon.svg"),
  search_icon: require("./asset/images/search-icon.svg"),
  question_icon: require("./asset/images/question-icon.svg"),
  kakao_icon: require("./asset/images/kakao-icon.png"),
  profile_default_icon: require("./asset/images/profile-default-icon.png"),
  profile_icon: require("./asset/images/profile-default-icon.png"),
  camera_icon: require("./asset/images/camera-icon.png"),
  apple_icon: require("./asset/images/apple-icon.png"),
  copy_icon: require("./asset/images/copy.png"),
  dot_icon: require("./asset/images/dot.svg"),
  reset_icon: require("./asset/images/reset.svg"),
  filter_icon: require("./asset/images/filter.svg"),
  fail_icon: require("./asset/images/fail_circle.svg"),

  main_register_bg: require("./asset/images/main-register-bg.png"),

  tip_1_1: require("./asset/images/tip1-1.png"),
  tip_1_2: require("./asset/images/tip1-2.png"),
  tip_2_1: require("./asset/images/tip2-1.png"),
  tip_2_2: require("./asset/images/tip2-2.png"),
  tip_3_1: require("./asset/images/tip3-1.png"),
  tip_3_2: require("./asset/images/tip3-2.png"),
};

export const fontWeight = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900,
};

export const fontFamily = {
  primary: "'Pretendard','Noto Sans KR', 'Roboto'",
};

export const light: Theme = {
  image,
  fontFamily,
  fontWeight,

  color: {
    white: "#ffffff",
    black: "#111111",
    mint: "#3EFFB3",
    light_mint: "#ECFFF8",
    gray: "#808080",
    orange: "#FF4808",
    green: "#00B585",
    light_green: "#E7FFF9",
    border_gray: "#F4F4F4",
    light_gray: "#cccccc",
    dark_gray: "#424242",
    yellow: "#ffe812",
  },

  shadow: {},
  radius: {},
};

export const dark: Theme = {
  image,
  fontFamily,
  fontWeight,

  color: {
    white: "#ffffff",
    black: "#111111",
    mint: "#3EFFB3",
    light_mint: "#ECFFF8",
    gray: "#808080",
    orange: "#FF4808",
    green: "#00B585",
    light_green: "#E7FFF9",
    border_gray: "#F4F4F4",
    light_gray: "#cccccc",
    dark_gray: "#424242",
    yellow: "#ffe812",
  },

  shadow: {},
  radius: {},
};
